import React, { Component } from 'react';
import { Col, Row, Container } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import SignInModal from './SignInModal';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';


class Home extends Component {
    state = {
        isOpen: false
    }

    render() {
        const { isOpen } = this.state;
        const { needLogin, t } = this.props;
        return (
            <div className="home">
                <div className="hero">
                    <Container>
                        <div className="text">
                            <h1>{t('home.welcome.title', { ns: 'common' })}</h1>
                            <h2>{t('home.welcome.slogan', { ns: 'common' })}</h2>
                            <p>{t('home.welcome.summary', { ns: 'common' })}</p>
                            <div className="btn-box">
                                <Link to="/about" className="btn">{t('home.welcome.moreInfo', { ns: 'common' })}</Link>
                                {needLogin &&
                                    <div className="btn" onClick={() => this.setState({ isOpen: !isOpen })}> {t('logIn', { ns: 'common' })}</div>
                                }
                            </div>
                        </div>
                    </Container>
                </div>

                <Container>

                    <Row className="icon-boxes">
                        <Col sm="4">
                            <span className="icon-box"><FontAwesomeIcon icon="thumbs-up" className="icon" /></span>
                            <h4>{t('home.keywords.simplicity.title', { ns: 'common' })}</h4>
                            <p>{t('home.keywords.simplicity.text', { ns: 'common' })}</p>
                        </Col>
                        <Col sm="4">
                            <span className="icon-box"><FontAwesomeIcon icon="folder-open" className="icon" /></span>
                            <h4>{t('home.keywords.transparency.title', { ns: 'common' })}</h4>
                            <p>{t('home.keywords.transparency.text', { ns: 'common' })}</p>
                        </Col>
                        <Col sm="4">
                            <span className="icon-box"><FontAwesomeIcon icon="rocket" className="icon" /></span>
                            <h4>{t('home.keywords.speed.title', { ns: 'common' })}</h4>
                            <p>{t('home.keywords.speed.text', { ns: 'common' })}</p>
                        </Col>
                    </Row>
                </Container>

                {isOpen && needLogin &&
                    <SignInModal
                    header={t('logIn', { ns: 'common' })}
                        isOpen={isOpen}
                        toggleModal={() => this.setState({ isOpen: !isOpen })}
                    />}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    needLogin: state.auth.needLogin
});

export default withTranslation('common')(connect(mapStateToProps, {})(Home));
